import { getCalApi } from '@calcom/embed-react'
import { useEffect, useRef } from 'react'

interface UseCalComOptions {
	namespace?: string
	layout?: 'month_view' | 'week_view' | 'column_view'
}

/**
 * Hook to initialize Cal.com embed API
 *
 * This hook ensures Cal.com is initialized only once and can be used
 * anywhere in the app without requiring the CalDotComWrapper component.
 *
 */
export function useCalCom({ namespace = 'bytebeam-101', layout = 'month_view' }: UseCalComOptions = {}) {
	const isInitialized = useRef(false)

	useEffect(() => {
		// Only initialize once per namespace
		if (isInitialized.current) {
			return
		}
		;(async function initializeCal(): Promise<void> {
			try {
				const cal = await getCalApi({ namespace })
				cal('ui', {
					layout,
				})
				isInitialized.current = true
			} catch (error) {
				console.error('Error initializing Cal.com:', error)
			}
		})()
	}, [namespace, layout])
}
